import { withCompInfo } from '@wix/editor-elements-integrations'
import type { MenuToggleCSS, MenuToggleDefinition } from './MenuToggle'

export const css = withCompInfo<MenuToggleCSS, MenuToggleDefinition>()(
	['compLayout', 'isMobileView', 'isOneDocMigrated'],
	({ compLayout, isMobileView, isOneDocMigrated }) => {
		return !isOneDocMigrated && compLayout.fixedPosition && isMobileView
			? {
				'margin-top': 'var(--wix-ads-height)',
				position: 'fixed !important',
				top: `${compLayout.y}px`,
				left: `${compLayout.x}px`,
			}
			: {}
	}
)
